import axios from "axios"
const apiToken = JSON.parse(localStorage.getItem("authUser"))
let UserType = JSON.parse(localStorage.getItem("WWINGS_USER_TYPE"))

const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

// Add Mutual Fund

export const addMutualFundAPI = async formData => {
    try {
        const apiToken = JSON.parse(localStorage.getItem("authUser"))
        const headers = {
        "Content-Type": "application/json",
        Authorization: apiToken, // Assuming token needs "Bearer" prefix
        Accept: "application/json",
        "Cache-Control": "no-cache",
        }

        const response = await axios.post(`${apiBaseUrl}/add-mutualFund`, formData, {
            headers,
        })
        return response
    } catch (error) {
        console.error("Error adding policy:", error)
        throw error
    }
}


// Update Mutual Fund

export const updateMutualFundAPI = async formData => {
    try {
        const apiToken = JSON.parse(localStorage.getItem("authUser"))
        const headers = {
        "Content-Type": "application/json",
        Authorization: apiToken, // Assuming token needs "Bearer" prefix
        Accept: "application/json",
        "Cache-Control": "no-cache",
        }

        const response = await axios.post(`${apiBaseUrl}/update-mutalFund`, formData, {
            headers,
        })
        return response
    } catch (error) {
        console.error("Error adding policy:", error)
        throw error
    }
}


// View Customer Mutual Funds

export const viewCustomerMutualFundAPI = async formData => {
    try {
        const apiToken = JSON.parse(localStorage.getItem("authUser"))
        const headers = {
        "Content-Type": "application/json",
        Authorization: apiToken, // Assuming token needs "Bearer" prefix
        Accept: "application/json",
        "Cache-Control": "no-cache",
        }

        const response = await axios.post(`${apiBaseUrl}/view-Cust-mutualFund`, formData, {
            headers,
        })
        return response
    } catch (error) {
        console.error("Error adding policy:", error)
        throw error
    }
}


// View Single Mutual Fund

export const ViewSingleMutualFundAPI = async formData => {
    try {
        const apiToken = JSON.parse(localStorage.getItem("authUser"))
        const headers = {
        "Content-Type": "application/json",
        Authorization: apiToken, // Assuming token needs "Bearer" prefix
        Accept: "application/json",
        "Cache-Control": "no-cache",
        }

        const response = await axios.post(`${apiBaseUrl}/view-SingleMutalFund`, formData, {
            headers,
        })
        return response
    } catch (error) {
        console.error("Error adding policy:", error)
        throw error
    }
}


// Mutual Fund Report

export const mutualFundReportAPI = async formData => {
    try {
        const apiToken = JSON.parse(localStorage.getItem("authUser"))
        const headers = {
            "Content-Type": "application/json",
            Authorization: apiToken,
            Accept: "application/json",
            "Cache-Control": "no-cache",
        }

        const response = await axios.post( `${apiBaseUrl}/mutualFunndReport`,  formData,  { headers })

        return response
    } catch (error) {
        console.error("Error fetching mutual fund report:", error)
        throw error
    }
}